import React from 'react'
import Hero from './Hero'
import Footer from "./Footer"

export default function Home() {
  return (
    <>
    <Hero />
    </>
  )
}
